const MAX_DELAY_MS = 2 ** 31 - 1;

export interface HostTimer { clear(): void; }

/**
 * setTimeout that survives delays beyond Node's 2^31-1 ms clamp by chaining:
 * delays above maxChunkMs are split into maxChunkMs hops that re-arm with the
 * remainder. maxChunkMs is injectable so tests can drive the chaining without
 * week-long waits. clear() cancels whichever chunk is currently live.
 */
export function hostTimeout(cb: () => void, delayMs: number, maxChunkMs: number = MAX_DELAY_MS): HostTimer {
  let handle: ReturnType<typeof setTimeout>;
  const arm = (remainingMs: number): void => {
    if (remainingMs > maxChunkMs) {
      handle = setTimeout(() => arm(remainingMs - maxChunkMs), maxChunkMs);    // wallclock-allow: host timer plumbing inside clock binding
    } else {
      handle = setTimeout(cb, remainingMs);    // wallclock-allow: host timer plumbing inside clock binding
    }
  };
  arm(delayMs);
  return { clear: () => clearTimeout(handle) };    // wallclock-allow: host timer plumbing inside clock binding
}
